// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2fzB6","icon":"style_icon__2XtHs","title":"style_title__2Ij-s"};